@if (decision_table?.framework.analysis_type) {
  @if (getAnalysisService().isMultiobjectiveByType(decision_table?.framework.analysis_type)) {
    <app-multiobjective-responses-evaluation [evaluationSessionId]="id" [allDecisionInfo]="allInfo" (responseEvaluationSavedEvent)="evaluationSaved()" (attachmentOnClickEvent)="attachmentOnClickEvent($event)"></app-multiobjective-responses-evaluation>
  }
}

@if (decision_table?.framework.analysis_type) {
  @if (getAnalysisService().isMulticriteriaByType(decision_table?.framework.analysis_type)) {
    <app-multicriteria-responses-evaluation [evaluationSessionId]="id" [allDecisionInfo]="allInfo" (responseEvaluationSavedEvent)="evaluationSaved()" (attachmentOnClickEvent)="attachmentOnClickEvent($event)"></app-multicriteria-responses-evaluation>
  }
}

@if (decision_table?.framework.analysis_type) {
  @if (getAnalysisService().isConsensusByType(decision_table?.framework.analysis_type)) {
    <app-consensus-responses-evaluation [evaluationSessionId]="id" [allDecisionInfo]="allInfo" (responseEvaluationSavedEvent)="evaluationSaved()" (attachmentOnClickEvent)="attachmentOnClickEvent($event)"></app-consensus-responses-evaluation>
  }
}
